import React from 'react';
import twMerge from 'utilities/src/twMerge';

type CardSummaryProps = {
  children: string;
  classes?: string;
};

function CardSummary({ children, classes = '' }: CardSummaryProps) {
  return (
    <div>
      <p className={twMerge('grow overflow-hidden', classes)}>{children}</p>
    </div>
  );
}

export default CardSummary;
